/**
 * Template for creating new exercises
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#fff',
    '& > div': {
      width: 700,
      maxWidth: 450,
      background: '#fff',
      padding: 20,
      MaxHeight: '100%',
      overflow: 'auto',
      textAlign: 'center',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

function NotAvail(props) {
  const classes = useStyles();
  const { close } = props.exerciseProps;

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Ćwiczenie niedostępne na urządzieniach mobilnych</h3>
        <p>Przepraszamy, ale ćwiczenie nie jest obecnie dostępne na urządzeniach mobilnych. Prosimy o wykonanie ćwiczenia na komputerze stacjonarnym.</p>
        <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(NotAvail);
